/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import TasksDashboard from './TasksDashboard'
import StudiesTable from './StudiesTable'
import SitesTable from './SitesTable'

/**
 * EOS Site User Dashboard - mirrors lego/page/home/eos/Page.jsx
 *
 * Renders the three EOS dashboard sections:
 * 1. TasksDashboard - User's pending EOS tasks with PDF preview
 * 2. StudiesTable - Studies assigned to the EOS site user
 * 3. SitesTable - Sites assigned to the EOS site user
 */
const PageHomeEos: React.FC = () => {
  return (
    <>
      <TasksDashboard />
      <StudiesTable />
      <SitesTable />
    </>
  )
}

export default PageHomeEos
